import lodashToNumber from 'lodash-es/toNumber';
import lodashToString from 'lodash-es/toString';
import type { LocationQuery } from 'vue-router';

import { BooleanQs } from '~/apiClient';

export const locationQueryAsOptionalString = (value: LocationQuery[string]): string | undefined => (value ? lodashToString(value) : undefined);

export const locationQueryAsOptionalNumber = (value: LocationQuery[string]): number | undefined =>
    Number.isFinite(+(value ?? '')) && lodashToString(value).length > 0 ? lodashToNumber(value) : undefined;

export const locationQueryAsStringArray = (value: LocationQuery[string]): string[] =>
    (Array.isArray(value) ? value : [value]).map(v => (v ? lodashToString(v) : undefined)).filter(v => typeof v === 'string') as string[];

export const locationQueryAsNumberArray = (value: LocationQuery[string]): number[] =>
    (Array.isArray(value) ? value : [value]).map(v => (v ? lodashToNumber(v) : undefined)).filter(v => typeof v === 'number') as number[];

export const locationQueryAsBoolean = (value: LocationQuery[string]): boolean => value === BooleanQs.true;

export const paramAsOptionalString = (value: string | string[]): string | undefined => (value ? lodashToString(value) : undefined);
